import Typography from "@mui/material/Typography";
import MainContainer from "components/layout/MainContainer/MainContainer";
import { PageContainer } from "components/UI/Structure/PageContainer";
import UploadedDocuments from "./UploadedDocuments";
import Suspenseful from "components/Suspenseful";
import { useOrbit } from "providers/OrbitProvider";
import { useParams } from "react-router-dom";
import { useMemo } from "react";
import { ContractRecord, getRecordIdentity } from "lib/DataModel";
import { InitializedRecord } from "@orbit/records";
import { useSuspenseQuery } from "@apollo/client";
import { GET_DOCUMENTS_QUERY } from "./queries";


export default function VendorDocumentPage() {
  const { store, getRemoteId } = useOrbit()
  const { contractId } = useParams()
  const contractFromRoute = contractId ? store.cache.query<ContractRecord>(q => q.findRecord(getRecordIdentity('contract', contractId))) : null
  const client = useMemo(() => contractFromRoute && store.cache.query(q => q.findRelatedRecord(contractFromRoute, 'client')) as InitializedRecord, [contractFromRoute, store])
  const clientId = client ? getRemoteId(client) : ''

  const { data: { documents }, refetch } = useSuspenseQuery(GET_DOCUMENTS_QUERY, {
    variables: { clientId: clientId }
  })

  return (
    <MainContainer>
      <PageContainer>
        <Typography variant='h1'>Documents</Typography>
        <Suspenseful
          component={UploadedDocuments}
          data={documents}
          refetch={refetch}
        />
      </PageContainer>
    </MainContainer>
  )
}
